import React from 'react';

import Image from 'next/legacy/image';

const getIconSrc = (position) => {
  if (position === 1) {
    return '/images/challengeBadgeFirst.svg';
  }
  if (position === 2) {
    return '/images/challengeBadgeSecond.svg';
  }
  if (position === 3) {
    return '/images/challengeBadgeThird.svg';
  }
  return '/images/challengeBadge.svg';
};

const ChallengeBadge = ({ position, height }) => {
  return (
    <Image
      alt={
        position
          ? `Badge for challenge position ${position}`
          : 'Challenge Badge'
      }
      className={`challenge-badge-${position}`}
      height={height}
      src={getIconSrc(position)}
      width={height}
    />
  );
};

export default ChallengeBadge;
